import * as React from "react";

export class Row extends React.Component<{}, {}> {

    render() {
        return (
            <div className="rj-sports-multiview__team-row">
                {this.props.children}
            </div>
        )
    }
}